import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import $ from 'jquery';
import ModalDialog from '../../components/modal-dialog';
import StatusOverview from '../../pages/status-overview/status-overview.jsx';
import sizes from '../../style/sizes';
import layout from '../../style/layout';

// import { stubStatusData } from '../../../lib/reward';

// TODO: Rename this to SupportButton to have consistent naming between frontend and backend

class InfoButton extends Component {
    state = { showStatusOverview: false };
    
    showStatusOverview() {
        // this.setState({ showStatusOverview: true });
        const showError = (error) => this.setState({ statusDataError: error });

        $.ajax({
            url: `${this.props.baseUrl}/api/sdk/rewards/${this.props.hashKey}`,
            method: 'GET',
        })
        .done((statusData, status, xhr) => {
            if (xhr.status !== 200) {
                showError(`Could not fetch status: code ${status}`);
            }

            // Use this to debug different cases with fake API response
            // this.setState({ statusData: stubStatusData });
            this.setState({
                statusData,
                showStatusOverview: true
            });
        })
        .fail(() => {
            showError('Sorry, could not fetch status.');
            this.setState({ showStatusOverview: false });
        });
    }

    render() {
        if (!this.props.isVisible) {
            return null;
        }

        return (<div className={this.props.className}>
            <button
              className="global-info-button"
              onClick={() => this.showStatusOverview()}
            >
                <img src="/icons/ic_info.svg" alt="Info" />
            </button>

            <ModalDialog
              isVisible={this.state.showStatusOverview}
              onClose={() => this.setState({ showStatusOverview: false })}
              dialogClassName="status-overview"
            >
                <StatusOverview
                  isVisible={this.state.showStatusOverview}
                  installId="123"
                  statusData={this.state.statusData}
                  baseUrl={this.props.baseUrl}
                  error={this.state.statusDataError}
                  onClose={() => this.setState({ showStatusOverview: false })}
                />
            </ModalDialog>
        </div>);
    }
}

InfoButton.propTypes = {
    isVisible: PropTypes.bool,
    baseUrl: PropTypes.string.isRequired,
    hashKey: PropTypes.string,
};

const smallScreensPadding = layout.smallScreens(`padding: ${sizes.smallPadding};`);

const StyledInfoButton = styled(InfoButton)`
    .global-info-button {
        transform: translateZ(0);
        top: 0;
        left: 0;
        position: fixed;
        padding: ${sizes.veryBigPadding};
        cursor: pointer;
    
        ${smallScreensPadding};

        border: none;
        background-color: transparent;
        ${layout.landscape(`
            top: auto;
            left: auto;
            right: 0;
            bottom: 0;
        `)}

        &:hover, &:active {
            -webkit-filter: brightness(90%);
        }

        &:focus {
            outline: none;
        }
    }
`;

export default StyledInfoButton;



// WEBPACK FOOTER //
// ./src/pages/status-overview/info-button.jsx